import { SAVE_DAILY_MONITORING_REPORT } from './actionTypes'


export function saveDailyMonitoringReport(data, key) {
    return {
        type: SAVE_DAILY_MONITORING_REPORT,
        payload: {value: data, key: key}
    }
}